import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import InvoiceItem from './InvoiceItem'
import InvoiceForm from './InvoiceForm'
import { InvoiceService } from '../../../services'
import { startFetch, endFetch } from '../../../actions/generalActions'

class InvoiceItemContainer extends Component {
  state = {
    invoice: null,
    products: [],
    headerErrors: {},
    fetchError: null,
  }

  componentDidMount() {
    this.fetchInvoice(this.props)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.fetchInvoice(this.props)
    }
  }

  fetchInvoice = ({ campaign, client, match }) => {
    this.props.startFetch()
    InvoiceService.getInvoiceDetail({
      clientId: client.slug,
      campaignId: campaign.slug,
      id: match.params.id,
    })
      .then(response => {
        const { invoice, invoice_products } = response.data
        this.setState({ invoice, products: invoice_products || [], fetchError: null })
        this.props.endFetch()
      })
      .catch(error => {
        this.props.endFetch()
        this.setState({ fetchError: error || new Error('Failed to load invoice') })
      })
  }

  handleProductCreation = ({ selectedCategory, selectedProduct, quantity }) => {
    const { campaign, client } = this.props
    const { invoice } = this.state

    this.props.startFetch()
    InvoiceService.addInvoiceProduct({
      clientId: client.slug,
      campaignId: campaign.slug,
      id: invoice.id,
      productId: selectedProduct.id,
      clientCategoryId: selectedCategory && selectedCategory.id,
      quantity: quantity,
    })
      .then(() => {
        this.fetchInvoice(this.props)
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  handleProductEdit = ({ selectedCategory, selectedProduct, quantity }, oldProduct) => {
    const { campaign, client } = this.props
    const { invoice } = this.state

    this.props.startFetch()
    InvoiceService.editInvoiceProduct({
      clientId: client.slug,
      campaignId: campaign.slug,
      invoiceId: invoice.id,
      productDetailId: oldProduct.id,
      productId: selectedProduct.id,
      clientCategoryId: selectedCategory && selectedCategory.id,
      quantity: quantity,
    })
      .then(() => {
        this.fetchInvoice(this.props)
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  handleProductRemove = (product) => {
    const { campaign, client } = this.props
    const { invoice } = this.state

    this.props.startFetch()
    InvoiceService.removeInvoiceProduct({
      clientId: client.slug,
      campaignId: campaign.slug,
      id: invoice.id,
      productDetailId: product.id,
    })
      .then(() => {
        this.fetchInvoice(this.props)
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  handleHeaderEdit = ({ number, invoiceDate, saleType, document }) => {
    const { campaign, client } = this.props
    const { invoice } = this.state

    this.props.startFetch()
    InvoiceService.editInvoiceHeader({
      clientId: client.slug,
      campaignId: campaign.slug,
      invoiceId: invoice.id,
      number,
      invoiceDate,
      saleType,
      document: document || {},
      name: document && document.name,
    })
      .then(() => {
        this.fetchInvoice(this.props)
        this.props.endFetch()
        this.setState({ headerErrors: {} })
      })
      .catch(error => {
        this.props.endFetch()
        if (error.response && error.response.data) {
          this.setState({ headerErrors: error.response.data })
        }
      })
  }

  handleSubmitToValidation = () => {
    const { campaign, client } = this.props
    const { invoice } = this.state

    this.props.startFetch()
    InvoiceService.sendToValidation({
      clientId: client.slug,
      campaignId: campaign.slug,
      id: invoice.id,
    })
      .then(() => {
        this.fetchInvoice(this.props)
        this.props.endFetch()
      })
      .catch(() => this.props.endFetch())
  }

  render() {
    const { campaign, client, linking, editable } = this.props
    const { invoice, products, headerErrors, fetchError } = this.state

    // Async errors (from Promise callbacks) can't be caught by React error boundaries
    // directly — they happen outside React's call stack. Throwing synchronously from
    // render() re-enters React's call stack, so the nearest ErrorBoundary catches it.
    if (fetchError) throw fetchError

    if (!invoice) return null

    // Draft invoices (status === 'created') → editable pre-populated form
    // Submitted/approved invoices → read-only card view
    if (editable && invoice.status === 'created') {
      return (
        <InvoiceForm
          campaign={campaign}
          client={client}
          invoice={invoice}
          saleTypes={invoice.sale_types || []}
          errors={headerErrors}
          serverProducts={products}
          onProductAdd={this.handleProductCreation}
          onProductRemove={this.handleProductRemove}
          onSaveDraft={this.handleHeaderEdit}
          onSubmitFatura={this.handleSubmitToValidation}
        />
      )
    }

    return (
      <InvoiceItem
        campaign={campaign}
        linking={linking}
        editable={false}
        invoice={invoice}
        products={products}
        headerErrors={headerErrors}
        saleTypes={invoice.sale_types || []}
        onProductCreation={this.handleProductCreation}
        onProductEdit={this.handleProductEdit}
        onProductRemove={this.handleProductRemove}
        onHeaderEdit={this.handleHeaderEdit}
        onSubmitToValidation={this.handleSubmitToValidation}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  startFetch: () => dispatch(startFetch()),
  endFetch: () => dispatch(endFetch()),
})

export default withRouter(connect(null, mapDispatchToProps)(InvoiceItemContainer))
